import React, { useState, useEffect } from 'react';
import useMediaQuery from '@mui/material/useMediaQuery';
import { Box, Typography, Table, TableBody, TableCell, TableHead, TableRow, Paper, CircularProgress, IconButton } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import { getVideos } from '../api';
import { usePartnerIndex, PartnerTag } from '../components/partnerTag';   // [D-770] чий це юзер

export default function VideosPage() {
  const deleteVideo = async (id) => {
    if (!window.confirm('Видалити відео з історії?')) return;
    try {
      const _tok = localStorage.getItem('dashboard_token');
      const _r = await fetch('/api/videos/' + id, { method: 'DELETE', headers: { 'Authorization': 'Bearer ' + _tok } });
      if (!_r.ok) throw new Error('fail');
      setVideos(videos.filter(v => v.id !== id));
    } catch(e) { alert('Помилка видалення'); }
  };
  const isMobile = useMediaQuery('(max-width:900px)');
  const [videos, setVideos] = useState([]);
  const [loading, setLoading] = useState(true);
  const { of, color } = usePartnerIndex();   // [D-770]

  useEffect(() => {
    getVideos(100).then(r => { setVideos(r.data); setLoading(false); });
  }, []);

  if (loading) return <Box sx={{ display: 'flex', justifyContent: 'center', mt: 10 }}><CircularProgress sx={{ color: 'var(--ac1, #7c4dff)' }}/></Box>;

  return (
    <Box>
      <Typography variant="h5" sx={{ color: '#fff', mb: 3, fontWeight: 'bold' }}>🎬 Відео ({videos.length})</Typography>
      <Paper sx={{ bgcolor: '#1a1a2e', border: '1px solid #333' }}>
        <Table size="small">
          <TableHead>
            <TableRow>
              {(isMobile ? ['Дата','Юзер','Трив.','Ціна'] : ['Дата','Юзер','Тривалість','AI модель','Вартість','Розділено']).map(h => (
                <TableCell key={h} sx={{ color: 'var(--ac1, #7c4dff)', borderBottom: '1px solid #333', fontWeight: 'bold' }}>{h}</TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {videos.map((v, i) => (
              <TableRow key={i} sx={{ '&:hover': { bgcolor: 'rgba(var(--ac1rgb, 124, 77, 255),0.05)' } }}>
                <TableCell sx={{ color: '#aaa', borderBottom: '1px solid #222' }}>{v.created_at ? isMobile ? v.created_at.substring(5,16) : v.created_at.substring(0,16) : '—'}</TableCell>
                <TableCell sx={{ color: '#fff', borderBottom: '1px solid #222' }}>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: .6, flexWrap: 'wrap' }}>
                    <span>@{v.telegram_username || '?'}</span>
                    <PartnerTag who={of(v.user_id)} color={color}/>{/* [D-770] */}
                  </Box>
                </TableCell>
                <TableCell sx={{ color: '#aaa', borderBottom: '1px solid #222' }}>{v.video_duration || 0}s</TableCell>
                {!isMobile && <TableCell sx={{ color: '#aaa', borderBottom: '1px solid #222' }}>{v.ai_model_used || '—'}</TableCell>}
                <TableCell sx={{ color: '#aaa', borderBottom: '1px solid #222' }}>${(v.ai_cost_usd || 0).toFixed(4)}</TableCell>
                {!isMobile && <TableCell sx={{ color: '#aaa', borderBottom: '1px solid #222' }}>{v.was_split ? 'Так' : 'Ні'}</TableCell>}
                <TableCell sx={{ borderBottom: '1px solid #222', p: 0.5 }}>
                  <IconButton size="small" onClick={() => deleteVideo(v.id)} sx={{ color: '#555', '&:hover': { color: '#f44336' } }}>
                    <DeleteIcon fontSize="small"/>
                  </IconButton>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Paper>
    </Box>
  );
}
